import { render, staticRenderFns } from "./list_comment_cell.vue?vue&type=template&id=9a01bf78&scoped=true&"
import script from "./list_comment_cell.vue?vue&type=script&lang=js&"
export * from "./list_comment_cell.vue?vue&type=script&lang=js&"
import style0 from "./list_comment_cell.vue?vue&type=style&index=0&id=9a01bf78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a01bf78",
  null
  
)

export default component.exports